import React from "react";
import {  useParams } from "react-router-dom";
import { ErrorReportData } from "../../../pages/reports/ErrorLogReport";
import { Card, CardBody, Col, Row,  } from "reactstrap";
import { H3,  H5,  P, UL } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";


function ErrorlogviewInfo() {
  const { id } = useParams();
  const { t } = useTranslation();
  const errorData = ErrorReportData.find((item) => item.id === Number(id));
  console.log(errorData, "idddddd");

  return (
    <div className="d-flex">
      <Col md={12}>
        <Card>
          <CardBody>
            {errorData ? (
              <>
                <Row className="mb-4">
                  <Col md="4" className="mb-3">
                    <div className="ttl-info text-start d-flex align-items-center">
                      <i className="fa fa-link text-primary me-2 fs-4" style={{paddingRight: '8px'}} />
                      <div>
                        <H5 className="mb-1 text-secondary">{t("URL")}</H5>
                        <span className="text-primary">{errorData.url}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md="4" className="mb-3">
                    <div className="ttl-info text-start d-flex align-items-center">
                      <i className="fa fa-database text-info me-2 fs-4" style={{paddingRight: '8px'}} />
                      <div>
                        <H5 className="mb-1 text-secondary">{t("Type")}</H5>
                        <span>{errorData.type}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md="4" className="mb-3">
                    <div className="ttl-info text-start d-flex align-items-center">
                      <i className="fa fa-check-circle text-success me-2 fs-4" style={{paddingRight: '8px'}} />
                      <div>
                        <H5 className="mb-1 text-secondary">{t("Status")}</H5>
                        <span>{errorData.status}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md="4" className="mb-3">
                    <div className="ttl-info text-start d-flex align-items-center">
                      <i className="icofont icofont-clock-time text-warning me-2 fs-4" style={{paddingRight: '8px'}} />
                      <div>
                        <H5 className="mb-1 text-secondary">{t("First Occurrence")}</H5>
                        <span>{errorData.firstOccurrenceTime}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md="4" className="mb-3">
                    <div className="ttl-info text-start d-flex align-items-center">
                      <i className="fa fa-calendar text-secondary me-2 fs-4" style={{paddingRight: '8px'}} />
                      <div>
                        <H5 className="mb-1 text-secondary">{t("Last Occurrence")}</H5>
                        <span>{errorData.lastOccurrenceTime}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md="4" className="mb-3">
                    <div className="ttl-info text-start d-flex align-items-center">
                      <i className="fa fa-list-ol text-danger me-2 fs-4" style={{paddingRight: '8px'}} />
                      <div>
                        <H5 className="mb-1 text-secondary">{t("No. of Occurrences")}</H5>
                        <span>{errorData.noOfOccurrence}</span>
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="job-description p-4 bg-light rounded border overflow-auto">
                  <H3 className="mb-2 text-secondary">{t("Error Description")}</H3>
                  <P className="text-start mb-0 text-danger ">{errorData.error_description}</P>
                </div>
              </>
            ) : (
              <P>{t("No error data found.")}</P>
            )}
          </CardBody>
        </Card>
      </Col>
    </div>
  );
}

export default ErrorlogviewInfo;
